const theme = {
  colors: {
    black: '#111',
    fontColor: '#fdfdfd',
    background: '#303030',
    headerBg: '#28ACBE',
    white: '#fefefe',
    right: '#0A8B77',
    wrong: '#A7647C',
    originalWrong: '#F483AB',
    originalRight: '#0CD0B2',
    neutral: '#789FD3'
  },
  fontFamily: 'Georgia, sans-serif',
  animationTime: '0.3s',
  boxShadows: {
    card1: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    card2: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)'
  }
}

export default theme
